import React, { useEffect, useRef, useCallback, useState, memo, useMemo } from 'react';
import { PromoColorsOptions, PromoVisualOptions } from '@box-types';
import classNames from 'classnames';
import { useVisibilityObserver } from '@box-react/hooks/use-visibility-observer';
import isEqual from 'lodash-es/isEqual';

function PromoTagComponent(input: { options: PromoVisualOptions; enableAnimations: boolean; className?: string }) {
  const { text, image, colors } = input.options;
  const containerRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  const useVisibilityObserverCallback = useCallback(
    () =>
      useVisibilityObserver({
        triggerOnce: true,
        onEnteredViewport: () => setVisible(true)
      }),
    []
  );
  const ref = input.enableAnimations ? useVisibilityObserverCallback() : null;

  const initializeColors = useCallback<(colors: PromoColorsOptions) => void>(
    (colors) => {
      const style = containerRef?.current?.style;
      if (!style || !colors) return;
      const { background, triangle, foreground, sideTag } = colors;

      style.setProperty('--background-color', background || '');
      style.setProperty('--triangle-color', triangle || '');
      style.setProperty('--font-color', foreground || '');
      style.setProperty('--side-tag-color', sideTag || background || '');
    },
    [colors]
  );

  useEffect(() => {
    initializeColors(colors);
  }, [colors]);

  return (
    <div
      className={classNames(
        'box-promo-tag-component',
        {
          'box-promo-tag-component-visible': input.enableAnimations ? visible : true
        },
        input?.className ?? ''
      )}
      ref={containerRef}
    >
      <div className="box-promo-tag-bg"></div>
      <div ref={ref} className="box-promo-tag-content">
        {image ? (
          <figure>
            <img src={image} alt={text} />
          </figure>
        ) : (
          <span className="ods-typography-microcopy-bold">{text}</span>
        )}
      </div>
    </div>
  );
}

const areEqual = (prevProps, nextProps) => {
  return isEqual(prevProps, nextProps);
};
export default memo(PromoTagComponent, areEqual);
